import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReturnableItemsWithQtyType } from 'features/Order/services/allOrder'

export const sliceName = 'allOrder'

export interface AllOrderInitialStateInterface {
  dialogState:
    | 'RETURN_VERIFICATION_DIALOG'
    | 'ON_HOLD_DIALOG'
    | 'SKIP_VERIFICATION_PACKAGE_DIALOG'
    | 'REDELIVERY_DIALOG'
    | 'RETURN_ORDER_DIALOG'
    | 'CANCEL_ORDER_DIALOG'
    | 'CLOSED'
  selectedOrderDate: ObjectNullType
  popUpSkipDropOff: 'SKIP_VERIFICATION_DROP_OFF' | 'CLOSED'
  returnableItems: ReturnableItemsWithQtyType
}

const initialState: AllOrderInitialStateInterface = {
  dialogState: 'CLOSED',
  selectedOrderDate: {},
  popUpSkipDropOff: 'CLOSED',
  returnableItems: [],
}

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setDialogState: (
      state,
      action: PayloadAction<AllOrderInitialStateInterface['dialogState']>,
    ) => {
      state.dialogState = action.payload
    },
    setSelectedOrderData: (
      state,
      action: PayloadAction<AllOrderInitialStateInterface['selectedOrderDate']>,
    ) => {
      state.selectedOrderDate = action.payload
    },
    setPopUpSkipDropOff: (
      state,
      action: PayloadAction<AllOrderInitialStateInterface['popUpSkipDropOff']>,
    ) => {
      state.popUpSkipDropOff = action.payload
    },
    setPopUpDone: (
      state,
      action: PayloadAction<AllOrderInitialStateInterface['popUpSkipDropOff']>,
    ) => {
      state.popUpSkipDropOff = action.payload
    },
    setReturnedItems: (
      state,
      action: PayloadAction<AllOrderInitialStateInterface['returnableItems']>,
    ) => {
      state.returnableItems = action.payload
    },
  },
})

export const { setDialogState, setSelectedOrderData, setPopUpSkipDropOff, setReturnedItems } =
  slice.actions

export default slice.reducer
